module.exports = __webpack_public_path__ + "img/replied.07e13c87.png";